import axios from 'axios';

import { API_URL } from '../config/settings';


const createUser = (user) => {

	const config = {
		headers: {
			'Content-Type': 'application/json',
		}
	}

	return axios.post(`${ API_URL }/owners/`, user, config);

}


export { createUser };
